import { render, staticRenderFns } from "./ScreenMorfologicaComDoppler.vue?vue&type=template&id=2f227790&scoped=true&"
import script from "./ScreenMorfologicaComDoppler.vue?vue&type=script&lang=js&"
export * from "./ScreenMorfologicaComDoppler.vue?vue&type=script&lang=js&"
import style0 from "./ScreenMorfologicaComDoppler.vue?vue&type=style&index=0&id=2f227790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f227790",
  null
  
)

export default component.exports